import React from 'react';
import ComingSoon from './ComingSoon';

const Flights = () => {
  return <ComingSoon title="Flight & Trains" />;
};

export default Flights;
